import React from 'react';
import PropTypes from 'prop-types';
import { Table, Thead, Tbody, Tr, Th } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Payment from 'components/payment/payment';
import Moment from 'moment';

import { CSVLink } from 'react-csv';

// eslint-disable-next-line no-unused-vars
import { paymentschedulecss } from './paymentschedule.css';

function PaymentContainer({ title, payments, incurredDate, incurredAmount }) {
  const formatedCSVData = () => {
    const incurredPayment = {
      id: 0,
      date: incurredDate,
      type: 'Debt',
      amount: -incurredAmount,
      remaining: incurredAmount,
      interest: 0,
    };
    payments.unshift(incurredPayment);
    const formattedData = payments.map(item => {
      const floatAmount = parseFloat(item.amount);
      return {
        date: new Moment(item.date).format('DD/MM/YYYY'),
        amount: Number.isNaN(floatAmount) ? '' : floatAmount.toFixed(2),
        remaining: parseFloat(item.remaining).toFixed(2),
        type: item.type,
      };
    });
    return formattedData;
  };

  return (
    <div className="payment-schedule">
      {title ? <h3>{title}</h3> : null}

      <Table className="table">
        <Thead>
          <Tr>
            <Th id="payment-date-title">Date</Th>
            <Th id="payment-amount-title">Scheduled amount</Th>
            <Th id="payment-remaining-title">Debt remaining</Th>
          </Tr>
        </Thead>
        <Tbody>
          {payments.map(item => (
            <Payment
              key={item.id}
              id={item.id}
              date={item.date}
              amount={item.amount}
              remaining={item.remaining}
              type={item.type}
            />
          ))}
        </Tbody>
      </Table>
      <div className="col">
        <CSVLink
          data={formatedCSVData()}
          filename="payments.csv"
          className="btn btn-primary civil-debt-button"
          target="_blank"
        >
          Export CSV
        </CSVLink>
      </div>
    </div>
  );
}

PaymentContainer.propTypes = {
  title: PropTypes.string,
  payments: PropTypes.instanceOf(Array),
  incurredDate: PropTypes.instanceOf(Date),
  incurredAmount: PropTypes.number,
};

export default PaymentContainer;
